const isLoggedIn = {
  __typename: 'isLoggedIn',
  login: false,
};

const defaults = { isLoggedIn };
export default { defaults };
